import styled from 'astroturf/react'
import _Wrapper from "styles-Wrapper.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/select_date_time/footer/styles.js?styleId=Wrapper";
import _AvatarsWrapper from "styles-AvatarsWrapper.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/select_date_time/footer/styles.js?styleId=AvatarsWrapper";
import _AvatarWrapper from "styles-AvatarWrapper.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/select_date_time/footer/styles.js?styleId=AvatarWrapper";
import _CounterWrapper from "styles-CounterWrapper.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/select_date_time/footer/styles.js?styleId=CounterWrapper";
import _StyledLabel from "styles-StyledLabel.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/select_date_time/footer/styles.js?styleId=StyledLabel";

const colorStrokeMedium = 'var(--colorStrokeMedium, var(--coreColorNeutral500))'
const colorTextStandard = 'var(--colorTextStandard, var(--coreColorNeutral900))'
const colorTextSecondary = 'var(--colorTextSecondary, var(--coreColorNeutral600))'
const colorStrokeStandard = 'var(--colorStrokeStandard, var(--coreColorNeutral400))'

const Wrapper = /*#__PURE__*/styled('div', null, {
  displayName: "Wrapper",
  styles: _Wrapper
})

const AvatarsWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "AvatarsWrapper",
  styles: _AvatarsWrapper
})

const AvatarWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "AvatarWrapper",
  styles: _AvatarWrapper
})

const CounterWrapper = /*#__PURE__*/styled(AvatarWrapper, null, {
  displayName: "CounterWrapper",
  styles: _CounterWrapper
})

const StyledLabel = /*#__PURE__*/styled('label', null, {
  displayName: "StyledLabel",
  styles: _StyledLabel
})

export {
  Wrapper,
  AvatarsWrapper,
  AvatarWrapper,
  CounterWrapper,
  StyledLabel
}
